import React from 'react';
import { Card } from 'antd';
import { GoZap } from 'react-icons/go';
import PropTypes from 'prop-types';

import ContactForm from './result-section/contactForm/ContactForm';

/**
 * @component
 * @category Search Page
 * @description When there is no results cards found in server response for FCL/LCL/AIR types, then this component is shown.
 * It also contains Contact Form which is shown, when browser url params has no user & verification params in it.
 * <br> <br>
 * **Example**
 * ```js
 *  <NoResult showSearchContactForm={true} isUserPresent={false}/>
 * ```
 */
const NoResult = (props) => {
  const { showSearchContactForm, isUserPresent, Clientoken } = props;
  let ClientTokenObject=Clientoken!==undefined?Clientoken:{}
  return (
    <>
      <div className="no-result" 
      // style={{ paddingTop: '135px' }}
      >
        {/* for contact form */}
        {showSearchContactForm && (!isUserPresent || ClientTokenObject.JWT_TOKEN !== undefined ) ? (
          <div className="no-result-card" style={{ height: 'auto' }}>
            <ContactForm />
          </div>
        ) : (
          // for no results card
          <Card className="no-result-card">
            <div className="no-result-card-content">
              <div
                style={{
                  fontSize: '16px',
                  maxWidth: '100px',
                  maxHeight: '100px',
                  color: '#08c',
                  margin: 'auto',
                  marginBottom: '20px',
                }}
              >
                <GoZap size={100} />
              </div>

              <div
                style={{
                  fontSize: '18px',
                  color: '#43637c',
                  height: 'auto',
                  maxWidth: '500px',
                  textAlign: 'center',
                  fontWeight: 500,
                  margin: 'auto',
                  marginBottom: '20px',
                  lineHeight: '25px',
                }}
                className="testR1"
              >
                <h4>There are no proposals in this direction at the moment.</h4>
              </div>
            </div>
          </Card>
        )}
      </div>
    </>
  );
};

NoResult.propTypes = {
  /**
   * whether to show Search Contact Form
   */
  showSearchContactForm: PropTypes.bool,
  /**
   * are both user and verification params present in the url
   */
  isUserPresent: PropTypes.bool,
};

export default NoResult;
